import * as Yup from "yup"

export const updateTradeSchema = Yup.object().shape({
  discount_percentage: Yup.number().required("This value is required"),
})
